import type { Ref } from 'vue';
import type { ContextType, ExtendedPartTagType } from '@/entities/rubrics';
import { getUrl } from '@/entities/rubrics';
import { useExcursionFiltersStore } from '@/entities/filter/store/excursion';
import type { CityTag } from '@/shared/api/experience';
import { allValue, DEFAULT_RUBRIC } from '@/widgets/rubricsBlock/excursion';
import { useTagRedirect } from '@/shared/lib/redirects/useTagRedirect';

export function useExcursionCitySelectedTag(cityTags: Ref<CityTag[] | undefined>, context: Ref<ContextType>) {
  const filterStore = useExcursionFiltersStore();

  const selectedTagFromRoute = computed(() => {
    const foundTag = cityTags.value?.find((tag) => tag.slug === filterStore.searchState.tag__slugs) ?? ({} as CityTag);

    return {
      value: foundTag?.slug || '',
      label: foundTag?.name || '',
      id: foundTag?.id || undefined,
      counter:
        foundTag.slug !== allValue
          ? (foundTag?.counters?.tours_count ?? 0) + (foundTag?.counters?.excursions_count ?? 0)
          : foundTag?.counters?.[`${context.value}_count`] || undefined,
      url: foundTag?.slug ? getUrl(foundTag, context.value) : undefined,
      seoUrl: foundTag.urls?.excursions || '',
      redirect: foundTag?.redirect || undefined,
      is_tours_included: !!foundTag?.flags?.is_tours_included,
    };
  });

  useTagRedirect(selectedTagFromRoute);

  const selectedValue = ref<ExtendedPartTagType>({ ...DEFAULT_RUBRIC });
  const cachedSelectedValue = ref<ExtendedPartTagType>({ ...DEFAULT_RUBRIC });

  watch(
    () => selectedTagFromRoute.value,
    (newSelectedTagFromRoute) => {
      if (newSelectedTagFromRoute.value) {
        selectedValue.value = newSelectedTagFromRoute;
        cachedSelectedValue.value = newSelectedTagFromRoute;
      }
    },
    { immediate: true },
  );

  return { selectedValue, cachedSelectedValue };
}
